/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowLineRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M189.65332,122.34326a8,8,0,0,1,0,11.31348l-72,72A8.0001,8.0001,0,0,1,103.99609,200V136h-72a8,8,0,0,1,0-16h72V56a8.0001,8.0001,0,0,1,13.65723-5.65674ZM216,32a8.00008,8.00008,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8.00008,8.00008,0,0,0,216,32Z" />
    </Svg>
  );
}

export default ArrowLineRight;
